import React, { FC } from 'react'
import Lottie from '@/components/Lottie'

/**
 * @component Footer
 * @description Page footer containing a centered Lottie animation.
 */
const Animation: FC = () => {
	return (
		<Lottie
			src="/lottie/footer/footer.json"
			loop
			autoplay
			className="shrink-0 h-56.25 w-750 md:h-75 pointer-events-none"
		/>
	)
}

export default Animation
